module.exports = __webpack_public_path__ + "static/media/grad03.fac94cf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/subotica/grad03.jpg
// module id = 448
// module chunks = 0